/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './uploadPart.defs.js'
export { main as default } from './uploadPart.defs.js'
